var _g, _circle, _path, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilestoneClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_866_246)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 34,
    width: 36,
    height: 36,
    rx: 2,
    fill: "url(#paint0_linear_866_246)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 34,
    width: 36,
    height: 36,
    rx: 2,
    stroke: "url(#paint1_linear_866_246)",
    strokeWidth: 0.5
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint2_linear_866_246)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.3892 56.9973C48.3892 51.1016 53.2126 46.3223 59.1627 46.3223H64.2263C70.1763 46.3223 74.9998 51.1016 74.9998 56.9973C74.9998 58.766 73.5528 60.1998 71.7677 60.1998H51.6212C49.8362 60.1998 48.3892 58.766 48.3892 56.9973Z",
    fill: "#393184"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2968 38.551C67.2968 41.6168 64.7886 44.102 61.6945 44.102C58.6005 44.102 56.0923 41.6168 56.0923 38.551C56.0923 35.4853 58.6005 33 61.6945 33C64.7886 33 67.2968 35.4853 67.2968 38.551Z",
    fill: "#393184"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_866_246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 39H60V63H45.5L42 66L38 63H24V39Z",
    fill: "url(#paint3_linear_866_246)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 39H60V63H45.5L42 66L38 63H24V39Z",
    stroke: "url(#paint4_linear_866_246)",
    strokeWidth: 0.5
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7464 48.9243C39.7464 50.3614 38.5773 51.5263 37.1351 51.5263C35.693 51.5263 34.5239 50.3614 34.5239 48.9243C34.5239 47.4872 35.693 46.3223 37.1351 46.3223C38.5773 46.3223 39.7464 47.4872 39.7464 48.9243Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9243 48.9243C43.9243 50.3614 42.7552 51.5263 41.3131 51.5263C39.8709 51.5263 38.7019 50.3614 38.7019 48.9243C38.7019 47.4872 39.8709 46.3223 41.3131 46.3223C42.7552 46.3223 43.9243 47.4872 43.9243 48.9243Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2241 54.6488L35.1536 50.6156L43.2946 50.6156L39.2241 54.6488Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7908 50.3554C40.7908 50.8584 40.2063 51.2661 39.4852 51.2661C38.7642 51.2661 38.1796 50.8584 38.1796 50.3554C38.1796 49.8525 38.7642 49.4447 39.4852 49.4447C40.2063 49.4447 40.7908 49.8525 40.7908 50.3554Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3503 46.3223V54.6488H49.3448V47.3793H49.2962L47.269 48.7292V47.7046L49.3448 46.3223H50.3503Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_866_246",
    x: 20.85,
    y: 30.85,
    width: 42.3,
    height: 42.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_866_246"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_866_246",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_866_246",
    x: 21.85,
    y: 36.85,
    width: 40.3,
    height: 31.3703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_866_246"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_866_246",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_866_246",
    x1: 27.8524,
    y1: 37.3214,
    x2: 66.7096,
    y2: 57.4412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABA3EE",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#ABA3EE",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABA3EE",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_866_246",
    x1: 45,
    y1: 40,
    x2: 58.5,
    y2: 71.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABA3EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_866_246",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_866_246",
    x1: 27.8524,
    y1: 41.4911,
    x2: 61.2223,
    y2: 64.5291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_866_246",
    x1: 45,
    y1: 43.5,
    x2: 53.1468,
    y2: 68.8457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneClient);
export default __webpack_public_path__ + "static/media/milestone-client.ae4d17ce562584e7d7352a45890c6ec4.svg";
export { ForwardRef as ReactComponent };